enum Operator {
  EQ = "equal",
  NEQ = "not_equal",
  EQ_SUP = "equal_or_superior",
  EQ_INF = "equal_or_inferior",
  SUP = "superior",
  INF = "inferior",
  PAT = "pattern",
  ISNOTPAT = "isNotPattern",
}

const isNotPattern = (current: String = "", valueToCompare: String = "") => {
  if (!current || current == null) {
    return false;
  } else {
    if (Array.isArray(current)) {
      const currentWord = current.join("||").toLowerCase();
      const patternWord = valueToCompare.toLowerCase();
      const result = !currentWord.includes(patternWord);

      return result;
    }
    const currentWord = current.toLowerCase();
    const patternWord = valueToCompare.toLowerCase();
    const result = !currentWord.includes(patternWord);

    return result;
  }
};
const isPattern = (current: String = "", valueToCompare: String = "") => {
  if (!current || current == null) {
    return false;
  } else {
    if (Array.isArray(current)) {
      const currentWord = current.join("||").toLowerCase();
      const patternWord = valueToCompare.toLowerCase();
      const result = currentWord.includes(patternWord);
      return result;
    }
    const currentWord = current.toLowerCase();
    const patternWord = valueToCompare.toLowerCase();
    const result = currentWord.includes(patternWord);
    return result;
  }
};
function evaluate(c: any, values: any[]): boolean {
  const { fieldToCompare, ifCondition, value } = c;
  const myArray = fieldToCompare.split("||");
  const entires = Object.keys(values).map(function (key) {
    return { key: key, value: values[key] };
  });

  const answer = entires.find(
    (element) => element.key === c.fieldToCompare || element.key === myArray[0],
  );

  if (!answer || !answer.value) return false;

  switch (ifCondition) {
    case Operator.EQ:
      return myArray[1]
        ? answer.value[myArray[1]] === value
        : answer.value === value;
    case Operator.NEQ:
      return answer.value !== value;
    case Operator.EQ_SUP:
      return Number(answer.value) >= Number(value);
    case Operator.EQ_INF:
      return Number(answer.value) <= Number(value);
    case Operator.SUP:
      return Number(answer.value) > Number(value);
    case Operator.INF:
      return Number(answer.value) < Number(value);
    case Operator.PAT:
      return isPattern(answer.value, value);
    case Operator.ISNOTPAT:
      return isNotPattern(answer.value, value);
    default:
      return false;
  }
}
export const resolver = (conditionalStatment: any, values) => {
  const { status, conditions, operator, action } = conditionalStatment;
  let shouldShow = true;
  let temp: boolean[] = [];

  if (status && action !== "E" && action !== "D") {
    conditions.map((c) => {
      temp.push(evaluate(c, values));
    });
    if (operator === "all") {
      temp.map((t) => {
        if (t == false) {
          shouldShow = false;
        }
      });
    } else if (operator === "one") {
      let b = false;

      temp.map((t) => {
        if (t == true) {
          b = true;
        }
      });
      b ? (shouldShow = true) : (shouldShow = false);
    }
  }

  switch (action) {
    case "S":
      return shouldShow;
    case "H":
      return !shouldShow;
    default:
      return shouldShow;
  }
};
export const resolverDisablingField = (
  conditionalStatment: any,
  values: any[],
) => {
  const { status, conditions, operator, action } = conditionalStatment;
  let shouldShow = true;
  let temp: boolean[] = [];

  if (status && action !== "S" && action !== "H") {
    conditions.map((c: any) => {
      temp.push(evaluate(c, values));
    });
    if (operator === "all") {
      temp.map((t) => {
        if (t == false) {
          shouldShow = false;
        }
      });
    } else if (operator === "one") {
      let b = false;

      temp.map((t) => {
        if (t == true) {
          b = true;
        }
      });
      b ? (shouldShow = true) : (shouldShow = false);
    }
  }

  switch (action) {
    case "D":
      return shouldShow;
    case "E":
      return !shouldShow;

    default:
      return !shouldShow;
  }
};
export const filterInputs = (elements: any[], elId: string) => {
  let filterdInputs: any[] = [];
  elements.map((e) => {
    if (
      e.id !== elId &&
      !e.content &&
      e.type !== "Image" &&
      e.type !== "Photo" &&
      e.type !== "ident" &&
      e.type !== "fullAdress" &&
      e.type !== "Signature" &&
      e.type !== "captcha"
    ) {
      if (e.type === "TableField") {
        e.lignes.map((l) => {
          let obj = new Object();
          obj["label"] = "grille_" + l.label;
          obj["field_name"] = `${e.field_name}||${l.label}`;
          filterdInputs.push(obj);
        });
      } else filterdInputs.push(e);
    }
  });
  return filterdInputs;
};
export const filterInputsForPage = (elements: any[]) => {
  let filterdInputs: any[] = [];
  elements.map((e) => {
    if (
      !e.content &&
      e.type !== "Image" &&
      e.type !== "Photo" &&
      e.type !== "ident" &&
      e.type !== "fullAdress" &&
      e.type !== "Signature" &&
      e.type !== "captcha"
    ) {
      if (e.type === "TableField") {
        e.lignes.map((l) => {
          let obj = new Object();
          obj["label"] = "grille_" + l.label;
          obj["field_name"] = `${e.field_name}||${l.label}`;

          filterdInputs.push(obj);
        });
      } else filterdInputs.push(e);
    }
  });

  return filterdInputs;
};
